import { useParams } from "react-router-dom";
import SubjectPage from "./subjects";
import { courses } from "../data/courses-data";

const SubjectWrapper = () => {
  const { slug } = useParams();
  const subject = courses.find((s) => s.slug === slug);

  if (!subject) return <h2>Course Not Found</h2>;
  return (
    <>
      <SubjectPage {...subject} />
    </>
  );
};

export default SubjectWrapper;
